import React, { useState } from "react";
import { Table } from "antd";
import { RiArrowLeftWideLine, RiArrowRightWideLine } from "react-icons/ri";

const Datatable = ({
  columns,
  dataSource,
  pagination,
  onSelectionChange,
  onPaginationChange,
  selectedRowKeys,
  loading,
  showRowSelection = true
}) => {
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const defaultPagination = {
    ...pagination,
    current: pagination?.current || 1,
    pageSize: pagination?.pageSize || 10,
    total: pagination?.total || 0,
    showQuickJumper: pagination?.showQuickJumper ?? true,
    showSizeChanger: pagination?.showSizeChanger ?? true,
    pageSizeOptions: pagination?.pageSizeOptions || ["10", "20", "30","100","500"],
    showTotal: pagination?.showTotal,

    onChange: (page, pageSize) => {
      if (onPaginationChange) {
        onPaginationChange(page, pageSize);
      }
    },

    itemRender: (_, type, originalElement) => {
      if (type === "prev") return <RiArrowLeftWideLine />;
      if (type === "next") return <RiArrowRightWideLine />;
      return originalElement;
    },
  };

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    // setSelectedRowKeys(newSelectedRowKeys);
    if (onSelectionChange) {
      onSelectionChange(newSelectedRowKeys, selectedRows);
    }
  };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };
  const rowSelection = showRowSelection
  ? {
      selectedRowKeys,
      onChange: onSelectChange,
    }
  : undefined;
  return (
    <>
      <Table
        // className="table datanew dataTable no-footer"
          className="table datanew dataTable no-footer full-height-table h-100"
        rowSelection={rowSelection}
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        bordered
        // scroll={{
        //   //  x: 'max-content', y: 300,
        //   scrollToFirstRowOnChange: true,
        // }}
        // scroll={{ y: "calc(100vh - 380px)" }}
        // scroll={{ x: "max-content" }}
        pagination={defaultPagination}
      />
    </>
  );
};

export default Datatable;
